import { BaseConfig } from "./base-config";

const generateStagingConfig = () => {
    return new BaseConfig({
        firebaseConfig: {
            apiKey: "AIzaSyCzuMEOKxdyuR5Wjl2vApsji12NNyjK4mc",
            authDomain: "partner-portal-staging-440112.firebaseapp.com",
            projectId: "partner-portal-staging-440112",
            storageBucket: "partner-portal-staging-440112.firebasestorage.app",
            messagingSenderId: "137825522572",
            appId: "1:137825522572:web:0cb4a30684995ca2513ca9",
        },
        jobPositionEmailRecipientLimit: 5,
        defaultApplicantManagerFirebaseUids: ["l0oZkMH6D9PmkUd0IuTNCvseZIK2"],
    });
};

export { generateStagingConfig };
